import { CreatePaperModelReq } from '@boi/shared-models';
import { Injectable } from '@nestjs/common';
import { Chapter } from '../../entities/chapter';
import { ChapterWiseModel } from '../entities/chapter-wise-model.entity';
import { QuestionPaperModal } from '../entities/question-paper-modal';
import { SectionWiseModel } from '../entities/section-wise-model.entity';

@Injectable()
export class QuestionPaperModalAdapter {
  /**
   *
   * @param CreatePaperModelReq
   * @returns Departments entity
   */

  getNote(languageWiseNote, lang: number) {
    const key = `note_${lang}`;
    const found = languageWiseNote.find(obj => key in obj);
    return found ? found[key] : null;
  }

  public convertDtoToEntity(createPaperModelReq: CreatePaperModelReq, isUpdate: boolean = false): QuestionPaperModal {
    const questionPaperModal = new QuestionPaperModal();
    questionPaperModal.class = createPaperModelReq.classId;
    questionPaperModal.instructions = createPaperModelReq.instructions[`instructions_${createPaperModelReq.language}`];
    questionPaperModal.language = createPaperModelReq.language;
    questionPaperModal.marks = createPaperModelReq.marks;
    questionPaperModal.noOfSections = createPaperModelReq.noOfSections;
    questionPaperModal.partName = createPaperModelReq.partName;
    questionPaperModal.subject = createPaperModelReq.subject;
    questionPaperModal.tagline = createPaperModelReq.tagline;
    questionPaperModal.timeLimit = createPaperModelReq.timeLimit;
    questionPaperModal.totalQuestions = createPaperModelReq.totalQuestions;
    questionPaperModal.bluePrintName = createPaperModelReq.bluePrintName;
    // questionPaperModal.defaultBluePrint = createPaperModelReq.defaultBluePrint;
    if (createPaperModelReq.id) {
      questionPaperModal.id = createPaperModelReq.id;
    }
    const sectionWiseModelArray: SectionWiseModel[] = [];
    let section = 1;
    for (const element of createPaperModelReq.sections) {
      const sectionWiseModel = new SectionWiseModel()
      sectionWiseModel.eachQnWeightage = element.eachQnWeightage;
      sectionWiseModel.mandatoryQns = element.mandatoryQns;
      sectionWiseModel.marks = element.marks;
      sectionWiseModel.noOfQns = element.noOfQns;
      sectionWiseModel.note = this.getNote(element.languageWiseNote, createPaperModelReq.language);
      sectionWiseModel.chapterWiseModel = [];
      sectionWiseModel.sectionNo = section;

      for (const chapterElement of element.chapterWiseData) {
        const chapterWiseModel = new ChapterWiseModel();
        const chapter = new Chapter()
        chapter.id = chapterElement.chapter
        chapterWiseModel.chapter = chapter;
        chapterWiseModel.noOfQns = chapterElement.noOfQns;
        chapterWiseModel.sectionWiseModel = sectionWiseModel;
        sectionWiseModel.chapterWiseModel.push(chapterWiseModel);
      }
      sectionWiseModelArray.push(sectionWiseModel);
      section++;
    }
    questionPaperModal.sectionsWiseModel = sectionWiseModelArray;
    return questionPaperModal;
  }

  public convertEntityToDto(paperModel: QuestionPaperModal): CreatePaperModelReq {
    const createPaperModelReq = new CreatePaperModelReq(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

    return createPaperModelReq;
  }
}
